(function () {
  class AnticipationView extends PIXI.Container {
    constructor() {
      super();
      this._anticipationReel0 = null;
      this._anticipationReel1 = null;
      this._anticipationReel2 = null;
      this._anticipationReel3 = null;
      this._anticipationReel4 = null;

      const self = this;
    }

    initialise() {
      const self = this;

      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    onLayoutComplete() {
      const baseName = "slotContainer:anticipationContainer:AnticipationView";

      this._anticipationReel0 = resourceManager.get(
        `${baseName}:reel0_anticipation`
      );
      this._anticipationReel0.gotoAndStop(0);
      this._anticipationReel0.visible = false;
      this._anticipationReel0.isAnticipationActive = false;

      this._anticipationReel1 = resourceManager.get(
        `${baseName}:reel1_anticipation`
      );
      this._anticipationReel1.gotoAndStop(0);
      this._anticipationReel1.visible = false;
      this._anticipationReel1.isAnticipationActive = false;

      this._anticipationReel2 = resourceManager.get(
        `${baseName}:reel2_anticipation`
      );
      this._anticipationReel2.gotoAndStop(0);
      this._anticipationReel2.visible = false;
      this._anticipationReel2.isAnticipationActive = false;

      this._anticipationReel3 = resourceManager.get(
        `${baseName}:reel3_anticipation`
      );
      this._anticipationReel3.gotoAndStop(0);
      this._anticipationReel3.visible = false;
      this._anticipationReel3.isAnticipationActive = false;

      this._anticipationReel4 = resourceManager.get(
        `${baseName}:reel4_anticipation`
      );
      this._anticipationReel4.gotoAndStop(0);
      this._anticipationReel4.visible = false;
      this._anticipationReel4.isAnticipationActive = false;
    }

    startAnticipation(reel) {
      const anticipationAnim = this[`_anticipationReel${reel}`];
      if (anticipationAnim != null && !anticipationAnim.isAnticipationActive) {
        anticipationAnim.visible = true;
        anticipationAnim.gotoAndPlay(0);
        anticipationAnim.isAnticipationActive = true;
        musicManager.playAnticipationSound();
      }
    }

    stopAnticipation(reel) {
      const anticipationAnim = this[`_anticipationReel${reel}`];
      if (anticipationAnim != null && anticipationAnim.isAnticipationActive) {
        anticipationAnim.isAnticipationActive = false;
        gsap.to(anticipationAnim, {
          alpha: 0,
          duration: 0.3,
          onComplete: () => {
            anticipationAnim.visible = false;
            anticipationAnim.alpha = 1;
            anticipationAnim.gotoAndStop(0);
          },
        });
      }
    }
  }

  create = function (json) {
    return new AnticipationView();
  };

  initialise = function (json, container, resources) {
    container.initialise();
  };

  getFilesRequired = function (json) {
    return ["", ""];
  };

  resourceManager.registerObjectType(
    "AnticipationView",
    create,
    initialise,
    getFilesRequired
  );
})();
